import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ResellerWithLicenses,
  AddResellerClientRequest,
} from "./reseller.interface";

@Injectable({
  providedIn: "root",
})
export class ResellerService {
  constructor(private http: HttpClient) {}

  getPartnersWithLicenses(): Observable<ResellerWithLicenses[]> {
    return this.http.get<ResellerWithLicenses[]>("/admin/reseller");
  }

  removeClient(resellerDomain: string, clientDomain: string): Observable<void> {
    return this.http.delete<void>(
      `/admin/resellers/${resellerDomain}/clients/${clientDomain}`,
    );
  }

  addClient(
    resellerDomain: string,
    request: AddResellerClientRequest,
  ): Observable<void> {
    return this.http.post<void>(
      `/admin/resellers/${resellerDomain}/clients`,
      request,
    );
  }

  attachDomain(resellerDomain: string, clientDomain: string): Observable<void> {
    return this.http.post<void>(
      `/admin/resellers/${resellerDomain}/attach/${clientDomain}`,
      {},
    );
  }

  detachDomain(resellerDomain: string, clientDomain: string): Observable<void> {
    return this.http.delete<void>(
      `/admin/resellers/${resellerDomain}/detach/${clientDomain}`,
    );
  }

  getAvailableClients(resellerDomain: string): Observable<string[]> {
    return this.http.get<string[]>("/admin/resellers/available-clients", {
      params: { resellerDomain },
    });
  }
}
